// For Lighthouse
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'

// Initialize Firebase
const firebaseConfigurations = {
  staging: {
    apiKey: 'AIzaSyA1UPH5eSfh_Qh5gEa_G5_o85C7caqh2S0',
    authDomain: 'lighthousestaging-e14af.firebaseapp.com',
    databaseURL: 'https://lighthousestaging-e14af-default-rtdb.firebaseio.com',
    projectId: 'lighthousestaging-e14af',
    storageBucket: 'lighthousestaging-e14af.appspot.com',
    messagingSenderId: '557378392344',
    appId: '1:557378392344:web:5247d385d954f7045f8e6d',
    measurementId: 'G-G71D8XC26R',
  },
  production: {
    apiKey: 'AIzaSyBUjTlAIxMWsaoi5_vnDCLDqcd6qCPQFeU',
    authDomain: 'bpm-cloudify.firebaseapp.com',
    databaseURL: 'https://bpm-cloudify-default-rtdb.firebaseio.com',
    projectId: 'bpm-cloudify',
    storageBucket: 'bpm-cloudify.appspot.com',
    messagingSenderId: '128624023223',
    appId: '1:128624023223:web:2e05098040a7277ae15f32',
    measurementId: 'G-S5M5FWJGFJ',
  },
}

firebase.initializeApp(process.env.VUE_APP_SERVERTYPE === 'production' ? firebaseConfigurations.production : firebaseConfigurations.staging)

const auth = firebase.auth()
const storage = firebase.storage()
const db = firebase.firestore()
const fs = firebase

export { auth, storage, db, fs }

// if (process.env.NODE_ENV === 'development') {
//   try {
//     firebase.firestore().useEmulator('localhost', process.env.VUE_APP_FIRESTOREPORT)
//     firebase.auth().useEmulator(`http://localhost:${process.env.VUE_APP_AUTHPORT}`)
//     firebase.database().useEmulator('localhost', process.env.VUE_APP_RTDBPORT)
//   } catch (err) {
//     // eslint-disable-next-line no-console
//     console.log(err.message)
//   }
// }
